const FETCH_CHANNEL_LIST_SUCCEEDED = 'FETCH_CHANNEL_LIST_SUCCEEDED';

const initState = {
  desktop: [],
  mobile: [],
};

const channelListReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case FETCH_CHANNEL_LIST_SUCCEEDED:
      return payload;

    default:
      return state;
  }
}

export default channelListReducer;
